import { createTermTagManager } from '../../utils/createTermTagManager';

export const newbuildingDoneYearGteTagManager = createTermTagManager({
  jsonQueryKey: 'yeargte',
  template: 'Год сдачи позднее %s',
  id: 'newbuildingYearGte',
});
